import React from 'react';
import {
    PageNotFound,
    Analytics,
    AiReviews,
    AiReviewsRegister,
    Orders,
    Marketplaces,
    Warehouse,
    Warehouses,
    Tools,
    Barcode,
    Offer,
    Settings,
    Billing,
    BillingRequests,
    Profile,
    SellerNew,
    Home,
    BillingPurchase,
    Products,
    TableWrapper,
    ProductsActive,
    ProductsFromOrders,
    PIMBarcodes,
    PIMImport,
    PIMExport,
    PIMSettings,
    PIMNew, PIMEdit,
    DasboardAdmin,
    Notifications,
    Fulfillment,
    ProductsShipment
} from '../pages';
import StocksFBS from "../pages/StocksFBS";
import ChangelogPage from "../pages/ChangelogPage";
import Delivery from "../pages/Delivery";
import StocksExport from "../pages/StocksExport";
import StocksFBO from "../pages/StocksFBO";
import StocksReserve from "../pages/StocksReserve";

interface IRoutePath {
    path: string,
    roles: Array<string>,
    element: any,
    needSellerId: boolean
}

export const routePaths: Array<IRoutePath> = [
    {
        path: "/",
        roles: ["manage-account-links"],
        element: Home,
        needSellerId: true
    },
    {
        path: "/:id/home/:tabName",
        roles: ["manage-account-links"],
        element: Home,
        needSellerId: true
    },
    {
        path: "/:id",
        roles: ["manage-account-links"],
        element: Home,
        needSellerId: true
    },
    {
        path: "/analytics",
        roles: ["manage-account-links"],
        element: Analytics,
        needSellerId: true
    },
    {
        path: "/:id/analytics",
        roles: ["manage-account-links"],
        element: Analytics,
        needSellerId: true
    },
    {
        path: "/ai-reviews/register",
        roles: ["manage-account-links"],
        element: AiReviewsRegister,
        needSellerId: true
    },
    {
        path: "/:id/ai-reviews/register",
        roles: ["manage-account-links"],
        element: AiReviewsRegister,
        needSellerId: true
    },
    {
        path: "/ai-reviews",
        roles: ["manage-account-links"],
        element: AiReviews,
        needSellerId: true
    },
    {
        path: "/:id/ai-reviews",
        roles: ["manage-account-links"],
        element: AiReviews,
        needSellerId: true
    },
    {
        path: "/orders",
        roles: ["manage-account-links"],
        element: Orders,
        needSellerId: true
    },
    {
        path: "/:id/orders",
        roles: ["manage-account-links"],
        element: Orders,
        needSellerId: true
    },
    {
        path: "/marketplaces",
        roles: ["manage-account-links"],
        element: Marketplaces,
        needSellerId: true
    },
    {
        path: "/:id/marketplaces",
        roles: ["manage-account-links"],
        element: Marketplaces,
        needSellerId: true
    },
    {
        path: "/warehouse",
        roles: ["manage-account-links"],
        element: Warehouse,
        needSellerId: true
    },
    {
        path: "/warehouses",
        roles: ["manage-account-links"],
        element: Warehouses,
        needSellerId: true
    },
    {
        path: "/:id/warehouses",
        roles: ["manage-account-links"],
        element: Warehouses,
        needSellerId: true
    },
    {
        path: "/tools",
        roles: ["manage-account-links"],
        element: Tools,
        needSellerId: true
    },
    {
        path: "/:id/tools",
        roles: ["manage-account-links"],
        element: Tools,
        needSellerId: true
    },
    {
        path: "/stocks-fbs",
        roles: ["manage-account-links"],
        element: StocksFBS,
        needSellerId: true
    },
    {
        path: "/:id/stocks-fbs",
        roles: ["manage-account-links"],
        element: StocksFBS,
        needSellerId: true
    },
    {
        path: "/stocks-fbo",
        roles: ["manage-account-links"],
        element: StocksFBO,
        needSellerId: true
    },
    {
        path: "/:id/stocks-fbo",
        roles: ["manage-account-links"],
        element: StocksFBO,
        needSellerId: true
    },
    {
        path: "/stocks-export",
        roles: ["manage-account-links"],
        element: StocksExport,
        needSellerId: true
    },
    {
        path: "/:id/stocks-export",
        roles: ["manage-account-links"],
        element: StocksExport,
        needSellerId: true
    },
    {
        path: "/stocks-reserve",
        roles: ["manage-account-links"],
        element: StocksReserve,
        needSellerId: true
    },
    {
        path: "/:id/stocks-reserve",
        roles: ["manage-account-links"],
        element: StocksReserve,
        needSellerId: true
    },
    {
        path: "/tools/barcode",
        roles: ["manage-account-links"],
        element: Barcode,
        needSellerId: true
    },
    {
        path: "/:id/delivery",
        roles: ["manage-account-links"],
        element: Delivery,
        needSellerId: true
    },
    {
        path: "/:id/ff",
        roles: ["manage-account-links"],
        element: Fulfillment,
        needSellerId: true
    },
    {
        path: "/:id/table-wrapper",
        roles: ["manage-account-links"],
        element: TableWrapper,
        needSellerId: true
    },
    {
        path: "/:id/products-shipment",
        roles: ["manage-account-links"],
        element: ProductsShipment,
        needSellerId: true
    },
    {
        path: "/:id/tools/barcode",
        roles: ["manage-account-links"],
        element: Barcode,
        needSellerId: true
    },
    {
        path: "/:id/warehouse",
        roles: ["manage-account-links"],
        element: Warehouse,
        needSellerId: true
    },
    {
        path: "/pim",
        roles: ["manage-account-links"],
        element: Products,
        needSellerId: true
    },
    {
        path: "/:id/pim",
        roles: ["manage-account-links"],
        element: Products,
        needSellerId: true
    },
    {
        path: "/pim/active",
        roles: ["manage-account-links"],
        element: ProductsActive,
        needSellerId: true
    },
    {
        path: "/:id/pim/active",
        roles: ["manage-account-links"],
        element: ProductsActive,
        needSellerId: true
    },
    {
        path: "/pim/from-orders",
        roles: ["manage-account-links"],
        element: ProductsFromOrders,
        needSellerId: true
    },
    {
        path: "/:id/pim/from-orders",
        roles: ["manage-account-links"],
        element: ProductsFromOrders,
        needSellerId: true
    },
    {
        path: "/pim/barcodes",
        roles: ["manage-account-links"],
        element: PIMBarcodes,
        needSellerId: true
    },
    {
        path: "/:id/pim/barcodes",
        roles: ["manage-account-links"],
        element: PIMBarcodes,
        needSellerId: true
    },
    {
        path: "/pim/import",
        roles: ["manage-account-links"],
        element: PIMImport,
        needSellerId: true
    },
    {
        path: "/:id/pim/import",
        roles: ["manage-account-links"],
        element: PIMImport,
        needSellerId: true
    },
    {
        path: "/pim/export",
        roles: ["manage-account-links"],
        element: PIMExport,
        needSellerId: true
    },
    {
        path: "/:id/pim/export",
        roles: ["manage-account-links"],
        element: PIMExport,
        needSellerId: true
    },
    {
        path: "/pim/settings",
        roles: ["manage-account-links"],
        element: PIMSettings,
        needSellerId: true
    },
    {
        path: "/:id/pim/settings",
        roles: ["manage-account-links"],
        element: PIMSettings,
        needSellerId: true
    },
    {
        path: "/pim/new",
        roles: ["manage-account-links"],
        element: PIMNew,
        needSellerId: true
    },
    {
        path: "/:id/pim/new",
        roles: ["manage-account-links"],
        element: PIMNew,
        needSellerId: true
    },
    {
        path: "/pim/edit/:productId",
        roles: ["manage-account-links"],
        element: PIMEdit,
        needSellerId: true
    },
    {
        path: "/:id/pim/edit/:productId",
        roles: ["manage-account-links"],
        element: PIMEdit,
        needSellerId: true
    },
    {
        path: "/offers",
        roles: ["manage-account-links"],
        element: Offer,
        needSellerId: true
    },
    {
        path: "/:id/offers",
        roles: ["manage-account-links"],
        element: Offer,
        needSellerId: true
    },
    {
        path: "/seller/edit/:sellerId",
        roles: ["manage-account-links"],
        element: Settings,
        needSellerId: true
    },
    {
        path: "/:id/seller/edit/:sellerId",
        roles: ["manage-account-links"],
        element: Settings,
        needSellerId: true
    },
    {
        path: "/:id/settings",
        roles: ["manage-account-links"],
        element: Settings,
        needSellerId: true
    },
    {
        path: "/billing",
        roles: ["manage-account-links"],
        element: Billing,
        needSellerId: false
    },
    {
        path: "/billing/*",
        roles: ["manage-account-links"],
        element: Billing,
        needSellerId: false
    },
    {
        path: "/profile",
        roles: ["manage-account-links"],
        element: Profile,
        needSellerId: false
    },
    {
        path: "/billing/purchase",
        roles: ["manage-account-links"],
        element: BillingPurchase,
        needSellerId: false
    },
    {
        path: "/billing/requests",
        roles: ["manage-account-links"],
        element: BillingRequests,
        needSellerId: true
    },
    {
        path: "/:id/billing/requests",
        roles: ["manage-account-links"],
        element: BillingRequests,
        needSellerId: true
    },
    {
        path: "/changelogs",
        roles: ["manage-account-links"],
        element: ChangelogPage,
        needSellerId: false
    },
    {
        path: "*",
        roles: ["manage-account-links"],
        element: PageNotFound,
        needSellerId: false
    },
    {
        path: "/settings",
        roles: ["manage-account-links"],
        element: DasboardAdmin,
        needSellerId: false
    },
    {
        path: "/:id/notifications",
        roles: ["manage-account-links"],
        element: Notifications,
        needSellerId: true
    },
]
